import { Link } from 'react-router-dom';

export default function SeoContentSection() {
  return (
    <section className="py-16 md:py-20 px-6 md:px-10 bg-background-100">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
          <div className="lg:w-3/5">
            <p className="text-foreground-400 text-sm font-medium uppercase tracking-wider mb-3">
              SEO Resource Center
            </p>
            <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-950 mb-6">
              What Is PandabuySpreadsheet &amp; Why Smart Shoppers Use It
            </h2>

            <div className="space-y-4 text-foreground-700 text-sm md:text-base leading-relaxed">
              <p>
                In today&apos;s overwhelming online marketplace, making informed purchasing decisions has never been more challenging.
                That&apos;s where <strong className="text-foreground-950">PandabuySpreadsheet</strong> comes in — a comprehensive,
                data-driven product comparison system designed for smart shoppers who want to maximize value and minimize risk.
              </p>
              <p>
                Unlike traditional shopping methods that rely on scattered reviews and gut feelings,
                <strong className="text-foreground-950"> pandabuyspreadsheet</strong> transforms messy product listings into clean,
                structured data tables. Compare prices instantly, evaluate quality scores, analyze shipping times versus costs,
                and find the best-value alternatives — all in one organized view.
              </p>
              <p>
                Whether you&apos;re hunting for the perfect sneakers, comparing jacket quality across suppliers, or tracking
                accessory price trends, our <strong className="text-foreground-950">product spreadsheet</strong> methodology
                gives you the clarity you need. Thousands of smart shoppers have already adopted this data-driven approach to
                reduce shopping risk by up to 60%.
              </p>
            </div>

            <div className="mt-8">
              <Link
                to="/blog/pandabuy-sheet-ultimate-guide"
                className="inline-flex items-center gap-2 px-6 py-3 rounded-full bg-accent-100 text-accent-900 font-medium text-sm hover:bg-accent-200 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <span>Read: Ultimate Pandabuy Sheet SEO Guide</span>
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>

            <div className="flex gap-12 md:gap-16 mt-10">
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">15+</p>
                <p className="text-foreground-500 text-xs mt-1">Product Categories</p>
              </div>
              <div>
                <p className="font-heading text-3xl md:text-4xl font-bold text-foreground-950">1000+</p>
                <p className="text-foreground-500 text-xs mt-1">Curated Items</p>
              </div>
            </div>
          </div>

          <div className="lg:w-2/5">
            <div className="relative rounded-2xl overflow-hidden h-80 md:h-96 lg:h-full min-h-[350px]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20minimalist%20home%20office%20with%20ultrawide%20monitor%20showing%20spreadsheet%20dashboard%20warm%20wood%20desk%20with%20coffee%20mug%20and%20small%20succulent%20plant%20large%20window%20with%20city%20skyline%20view%20late%20afternoon%20golden%20light%20professional%20yet%20cozy%20atmosphere&width=800&height=1000&seq=seo-v2-workspace&orientation=portrait"
                alt="PandabuySpreadsheet workspace with data comparison"
                className="w-full h-full object-cover object-top"
                title="PandabuySpreadsheet - Data-Driven Shopping Workspace"
              />
              <div className="absolute top-5 left-5">
                <span className="inline-block px-3 py-1.5 rounded-full bg-background-50/90 text-foreground-800 text-xs font-medium backdrop-blur-sm">
                  2026 Edition
                </span>
              </div>
              <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/60 to-transparent p-5">
                <p className="text-background-50 font-medium text-sm">Structured Data Analysis</p>
                <p className="text-background-50/75 text-xs mt-1">Real-time product comparison tables</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}